import JobListPage from './JobListPage';

export default JobListPage;